import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ITableColumn } from './tabela-parametrizacao-acessos.model';

@Component({
  selector: 'app-tabela-parametrizacao-acessos',
  templateUrl: './tabela-parametrizacao-acessos.component.html',
  styleUrls: ['./tabela-parametrizacao-acessos.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TabelaParametrizacaoAcessosComponent),
      multi: true
    }
  ]
})
export class TabelaParametrizacaoAcessosComponent implements OnInit {
  @Input() data: any[] = [];
  @Input() columns: ITableColumn[] = [];
  @Output() ngModelChange: EventEmitter<any> = new EventEmitter();

  visibleColumns: ITableColumn[] = [];
  selectedItem: any;
  selectedRowIndex: number | null = null;

  constructor() {}

  ngOnInit() {
    const availableKeys = new Set(this.data.flatMap(item => Object.keys(item)));
    this.visibleColumns = this.columns.filter(column =>
      availableKeys.has(column.key)
    );
  }

  onSelectChange(value: any, item: any) {
    const body = {
      value: value,
      item: item
    };
    this.ngModelChange.emit(body);
  }

  toggleAtivo(item: any) {
    item.ativo = !item.ativo;
    this.selectedItem = item;
  }

  selectRow(index: number) {
    if (this.selectedRowIndex === index) {
      this.selectedRowIndex = null;
    } else {
      this.selectedRowIndex = index;
    }
  }
}
